export const StateColors = {
  EXPIRED: '#ff7043',
  PENDING: 'rgb(128, 231, 255)',
  NEAR_EXPIRATION: '#ffd740',
  ON_GOING: '#b2ff59',
}

export const STATE_COLOR_OPACITY = .7